import {IconLoadingCircleSolid} from '@baidu/ee-icon/svg';
import styles from './index.less';

const Loading = () => (
    <div className={styles.loadingWrapper}>
        <IconLoadingCircleSolid className={styles.loading} />
    </div>
);

export default Loading;
